import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as BetaFeaturesActions from './beta-features.actions';
import * as BetaFeaturesSelectors from './beta-features.selectors';

@Injectable({
  providedIn: 'root'
})
export class BetaFeaturesFacade {
  betaFeaturesEnabled$: Observable<boolean> = this.store.select(
    BetaFeaturesSelectors.selectBetaFeaturesEnabled
  );

  constructor(private store: Store) {}

  loadBetaFeatures(): void {
    this.store.dispatch(BetaFeaturesActions.loadBetaFeatures());
  }

  enableBetaFeatures(): void {
    this.store.dispatch(BetaFeaturesActions.enableBetaFeatures());
  }

  disableBetaFeatures(): void {
    this.store.dispatch(BetaFeaturesActions.disableBetaFeatures());
  }

  setBetaFeatures(enabled: boolean): void {
    this.store.dispatch(BetaFeaturesActions.setBetaFeatures({ enabled }));
  }
}
